import { ClientDto } from '../client/ClientDto';
import { AgentDto } from '../agent/AgentDto';

import { ClientAgentDto } from './ClientAgentDto';
import { ClientAgentAliasDto } from './ClientAgentAliasDto';
import { ClientAgentJurisdictionDto } from './ClientAgentJurisdictionDto';
import { CountryDto } from '../CountryDto';

export interface ClientAgentInfoDto {
    PendingFileParseUploadId: Guid | undefined;
    FileParseUploadId: Guid | undefined;
    ClientAgentId: number;
    Client: ClientDto;
    Agent: AgentDto;    
    PrimaryAlias: ClientAgentAliasDto;
    Jurisdictions: Array<ClientAgentJurisdictionDto>;
    AgentEmail: string;
    AgentCCEmail: string;
    IsUnrecognizedAgent: boolean;
    JurisdictionFree: boolean;
    UnsetCountries: Array<CountryDto>;
    OriginalAgentId?: Guid;
    VendorNumber?: string;
}

export class ClientAgentInfoDto implements ClientAgentInfoDto {
    ClientAgent = -1;
    Client = new ClientDto();
    Agent = new AgentDto();
    PrimaryAlias = new ClientAgentAliasDto();
    Jurisdictions: Array<ClientAgentJurisdictionDto> = [];
    AgentEmail = "";
    AgentCCEmail = "";
    IsUnrecognizedAgent = false;
    JurisdictionFree = false;
    UnsetCountries: Array<CountryDto> = [];
}